module.exports = __webpack_public_path__ + "static/media/oc.6bbd962c.svg";